import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';

import { FleetChecklistNavigationService } from '../../services/fleet-checklist-navigation.service';
import {FleetChecklist, FleetChecklistType } from 'src/app/validation/models/fleet-checklist';
import {FleetChecklistEditorService} from '../../services/fleet-checklist-editor.service';

@Component({
  selector: 'app-fleet-checklist-create-view',
  templateUrl: './fleet-checklist-create-view.component.html',
  styleUrls: [
    './fleet-checklist-create-view.component.scss',
    '../../styles/styles-component.scss',
  ],
})
export class FleetChecklistCreateViewComponent implements OnInit {
  @Output() onCreated = new EventEmitter<FleetChecklist>();
  submitted: boolean = false;

  constructor(
    public editor : FleetChecklistEditorService,
    private navigation: FleetChecklistNavigationService
  ) { }

  get f() {
    return this.editor.form.controls;
  }

  ngOnInit(): void { }

  async onSubmit() {
    this.submitted = true;
    if(this.editor.isFormValid()){
      let result = await Swal.fire({
        title: '¿Crear grupo de validación Vehicular?',
        html: `
          <div class="text-start">
            <p>
              Se creará el grupo:
              <strong>${this.f.name.value}</strong>
            </p>
            <p>
              Vehículos seleccionados:
              <strong>${this.f.vehicles.value.length}</strong>
            </p>
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, crear',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3b82f6',
        cancelButtonColor: '#ebebeb',
        reverseButtons: true
      })
      if(!result.isConfirmed) return;
      let created = await this.editor.onCreate();

      if(!created) {
        Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al crear el grupo de validación.',
          icon: 'error',
          confirmButtonColor: '#3b82f6',
        });
      } else {
        this.onCreated.emit(created);
        this.submitted = false;
        await Swal.fire({
          title: '¡Grupo creado!',
          text: `El grupo de validación "${this.f.name.value}" se ha creado con éxito y se abrieron los detalles en una nueva pestaña.`,
          icon: 'success',
          confirmButtonColor: '#3b82f6',
          timer: 3000,
          timerProgressBar: true,
        });
        this.editor.closeModals();
        this.navigation.openChecklist(created.id);
      };
    }
  }

  onCancel(): void {
    this.editor.closeModals();
  }
}
